import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { IFeature, IRoleFeatureConfig } from '../../entities/Feature/Feature';

export class FeaturesApi extends BaseApi {
  private static baseApiUrl: string = `${BaseApi.apiUrl}/Features`;

  public static apiUrls = {
    visible: `${FeaturesApi.baseApiUrl}/Visible`,
    all: `${FeaturesApi.baseApiUrl}`,
    roleConfig: `${FeaturesApi.baseApiUrl}/Roles/:id`,
    enabled: `${FeaturesApi.baseApiUrl}/:id/Enabled`,
  };

  public static async getVisibleFeatures(
    facilityId?: number,
  ): Promise<string[]> {
    return this.sendApiRequest<string[]>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.visible,
      data: facilityId ? ({ facilityId } as any) : undefined,
    });
  }

  public static async getAllFeatures(): Promise<IFeature[]> {
    return this.sendApiRequest<IFeature[]>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.all,
    });
  }

  public static async getRoleFeatureConfig(
    roleTypeId: number,
  ): Promise<IRoleFeatureConfig> {
    return this.sendApiRequest<IRoleFeatureConfig>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.roleConfig,
      id: roleTypeId.toString(),
    });
  }

  public static async setRoleFeatures(
    roleTypeId: number,
    featureIds: number[],
  ): Promise<void> {
    return this.sendApiRequest<void>({
      method: HttpMethodEnum.PUT,
      path: this.apiUrls.roleConfig,
      data: featureIds as any,
      id: roleTypeId.toString(),
    });
  }

  public static async setFeatureEnabled(
    featureId: number,
    isEnabled: boolean,
  ): Promise<void> {
    return this.sendApiRequest<void>({
      method: HttpMethodEnum.PUT,
      path: this.apiUrls.enabled,
      data: { isEnabled } as any,
      id: featureId.toString(),
    });
  }
}
